export { default as SvgInfo } from './info'
